import React, { useEffect, useState } from 'react';
import { FormSectionElements, ProgramContainer } from 'src/entities/formTemplateDataType';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent } from '../../utilities/ElementUtils';
import CMAUtils from '../../utilities/CMAUtils';
import axios from 'axios';
import SessionStorageService from '../../services/SessionStorageService';
import { formatDateCustom } from '../../utilities/DateUtils';
import URLUtils from '../../utilities/URLUtils';
import { TOKEN_TYPE } from '../../entities/Constants';

export type TableProps = {
    isEng: boolean;
    field: FormSectionElements;
    callbackStepIndex?: (index: number, returnIndex?: number) => void;
    callback?: (programContainer: ProgramContainer) => void
}

const SummaryListComponent = ({ field, isEng, callbackStepIndex, callback }: TableProps) => {
    const [data, setData] = useState<any[]>([]); // Store fetched data as an array
    const [isLoading, setIsLoading] = useState<boolean>(true); // Track loading state

    useEffect(() => {
        const getListDataSource = async () => {
            const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
            const headers = {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            };

            // const programContainer = field.parent.parent.parent as ProgramContainer;
            // const baseUri = programContainer.APIBasePath;
            const api = URLUtils.concatUrls(field.LovAPI);

            try {
                let response = await axios.get(api, { withCredentials: true, headers: headers });

                if (Array.isArray(response.data)) {
                    setData(response.data); // Ensure data is an array before setting state
                } else {
                    console.error("Expected an array but got:", response.data);
                    setData([]); // Default to empty array if data is invalid
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false); // Stop loading indicator
            }
        };

        getListDataSource();
    }, []);

    // Show loading indicator while fetching data
    if (isLoading) {
        return <p>Loading...</p>;
    }

    // Ensure data is available before rendering
    if (!data || data.length === 0) {
        return <p>No data available</p>;
    }

    // Process the fetched data
    const caption = isEng ? field.ENUTitle : field.FRATitle;
    let listHtml: JSX.Element[] = [];
    FormValidationUtils.runJavascript(field);

    const elements = field.subSectionList[0].ListOfFormSectionElements;
    console.log("Fetched Data:", data);
    console.log("Elements:", elements);
    let tableHeader = [];

    elements.forEach(ele => {
        tableHeader.push(<th scope="col">
            {ele.ENUTitle}
        </th>)
    })


    let rowHtml: JSX.Element[] = [];
    data.forEach((record) => {

        let keyValue: string | undefined;
        let singleRowHtml: JSX.Element[] = [];
        elements.forEach((column) => {
            switch (column.Datatype) {
                case "CMAKey":
                    singleRowHtml.push(
                        <th scope="row">
                            <a href="#" data-status={record.status} onClick={async (event) => {
                                const status = event.currentTarget.dataset.status;
                                event.preventDefault();
                                const programContainer = getRootComponent(field);
                                programContainer.Template = record[column.LoadBindName];
                                programContainer.orgId=record["orgId"];
                                programContainer.userRole=record["userRole"];
                                programContainer.organizationName=record["organizationName"];
                                CMAUtils.generateCMASection(programContainer);
                                await CMAUtils.retrieveFormData(programContainer, status);
                                callbackStepIndex(3);
                            }}>
                                <div dangerouslySetInnerHTML={{__html: record["formattedTemplateAssessment"]}} />
                            </a>
                        </th>);
                    break;
                case "CMAButton":
                    singleRowHtml.push(
                        <dd key={`button-${record.id}`}>
                            <button className="ontario-button ontario-button--secondary" onClick={() => {
                                const programContainer = getRootComponent(field);
                                programContainer.Template = keyValue!;
                                CMAUtils.generateCMASection(programContainer);
                                callbackStepIndex?.(3);
                            }}>
                                {column.ENUTitle}
                            </button>
                        </dd>
                    );
                    break;
                case "Text":
                    singleRowHtml.push(
                        <td>
                            {record[column.LoadBindName]}
                        </td>
                    );
                    break;
                case "Date":
                    singleRowHtml.push(
                        <td>
                        {formatDateCustom(record[column.LoadBindName])}
                    </td>
                    );
                    break;
            }

            
        })
rowHtml.push(<tr>{...singleRowHtml}</tr>);
    });

    listHtml.push(
        <div className="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
            <div className="ontario-table-scroll--wrapper">
                <div className="ontario-table-scroll--div"></div>
            </div>
            <div className="ontario-table-div">
                <table>
                    <caption>{caption}</caption>
                    <thead>
                        <tr>
                            {tableHeader}
                        </tr>
                    </thead>
                    <tbody>
                        {rowHtml}
                    </tbody>
                </table>
            </div>
        </div>)


    return (
        <div className="ontario-summary-list">
            <dl className="ontario-summary-list__container">
                {listHtml}
            </dl>
        </div>
    );
};

export default SummaryListComponent;
